import { useLocation } from '@reach/router'
import React, { useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { RealEstateDataPage, RealEstateDataPageComponentData } from 'types'
import { Link } from 'gatsby'
import { normalizeURL } from '@helpers/helper.rendering'

interface ExternalProps {
  titlePage: string
  noveltyId?: string
  developmentId?: string
  propertyId?: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const BreadCrumbs_1 = (props: CombinedProps) => {
  const {
    isDemo,
    align,
    titlePage,
    global_data,
    underlineMode,
    opacityValue,
    spanText,
    titleColor,
    titleHexa,
    titleInTop,
    title,
  } = props

  const pages: RealEstateDataPage[] = global_data?.content?.pages ?? []

  const { divisionPath } = global_data

  const homePage = pages.find((element) => element.path === '/')

  const { pathname } = useLocation()

  const isDevelopment = pathname.includes('/emprendimiento/')
  const isProperty = pathname.includes('/propiedad/')
  const isNovelty = pathname.includes('/novedad/')

  const pathnameNormalize = normalizeURL(pathname)

  function filterItems(elemento: string) {
    return !/^\d+$/.test(elemento)
  }

  function generarBreadcrumb(pathname: string) {
    const items = pathname.split('/').filter((item) => item !== '') // Separar el pathname en partes

    interface Type {
      nombre: string
      url?: string
      active?: Boolean
    }

    let breadcrumb: Type[] = items.map((item, index) => {
      const breadcrumbItem = {
        nombre: item.replace(/-/g, ' '), // Reemplazar guiones con espacios
        url: ('/' + items.slice(0, index + 1).join('/')).replaceAll('/propiedad', ''), // Construir la URL para cada item
      }
      return breadcrumbItem
    })

    // Cambiar el nombre para el primer elemento según tu ejemplo

    isNovelty
      ? breadcrumb.unshift({
          nombre: 'Novedades',
          url:
            (process.env.GATSBY_IS_SITE_COMPILER === 'true' ? `${divisionPath}` : '') +
            '/novedades',
        })
      : null
    isNovelty
      ? (breadcrumb[3].nombre = breadcrumb[3].nombre.replace(breadcrumb[2].nombre, ''))
      : null

    breadcrumb = breadcrumb.filter(
      (e) =>
        filterItems(e.nombre) &&
        e.nombre.toLowerCase() !== 'emprendimiento' &&
        e.nombre.toLowerCase() !== 'novedad' &&
        e.nombre.toLowerCase() !== 'propiedad' &&
        e.url?.toLowerCase() !== divisionPath &&
        e.url?.toLowerCase() !== divisionPath?.toLowerCase(),
    )

    isDevelopment
      ? breadcrumb.unshift({
          nombre: 'Emprendimientos',
          url:
            (process.env.GATSBY_IS_SITE_COMPILER === 'true' ? `${divisionPath}` : '') +
            '/emprendimientos',
        })
      : null

    breadcrumb.unshift({
      nombre: homePage?.title!,
      url: process.env.GATSBY_IS_SITE_COMPILER === 'true' ? `${divisionPath}` : '/',
    })

    return breadcrumb
  }

  return (
    <div
      style={{
        backgroundColor: opacityValue || 'transparent',
      }}
      className={titleInTop ? 'd-flex align-items-end h-100' : 'background'}
    >
      <style>
        {`\
          :root{\
            --breadcrumb-divider: ${spanText?.toString()! ?? ':'};\
          }\
        `}
      </style>
      <Container fluid>
        <div
          className={
            'breadcrumb-div w-100 a pb-0 pb-lg-0 ' +
            (false && 'skeleton') +
            (underlineMode ? ' capsuled ' : '')
          }
          style={{
            position: 'relative',
            zIndex: '9',
          }}
        >
          <nav
            //@ts-ignore
            style={{ '--bs-breadcrumb-divider': `'${spanText ?? '>'}'` }}
            aria-label="breadcrumb"
          >
            <ol
              className={
                'breadcrumb d-flex mb-0 ' +
                (align === 'left' ? 'justify-content-start' : 'justify-content-center')
              }
            >
              {title ? (
                <li
                  className={`breadcrumb-item text-decoration-none text-capitalize ${titleColor}`}
                  style={{ color: titleColor === 'text-picker' ? titleHexa : '' }}
                >
                  <a>{title}</a>
                </li>
              ) : pathname.includes('propiedad') ||
                pathname.includes('emprendimiento/') ||
                pathname.includes('novedad') ? (
                generarBreadcrumb(pathnameNormalize).map((item, index) => (
                  <li
                    key={index}
                    className={'breadcrumb-item text-decoration-none text-capitalize '}
                    style={{ color: titleColor === 'text-picker' ? titleHexa : '' }}
                  >
                    {' '}
                    {item.active ? (
                      item.nombre
                    ) : (
                      <Link
                        className={`text-capitalize text-decoration-none ${titleColor}`}
                        style={{ color: titleColor === 'text-picker' ? titleHexa : '' }}
                        to={item?.url!}
                      >
                        {item.nombre}
                      </Link>
                    )}{' '}
                  </li>
                ))
              ) : (
                <>
                  <li className={'breadcrumb-item text-decoration-none text-capitalize '}>
                    <Link
                      className={`text-decoration-none ${titleColor}`}
                      style={{ color: titleColor === 'text-picker' ? titleHexa : '' }}
                      to={process.env.GATSBY_IS_SITE_COMPILER === 'true' ? `${divisionPath}` : '/'}
                    >
                      {homePage?.title}
                    </Link>{' '}
                  </li>
                  {titlePage.toLowerCase() !== 'inicio' && titlePage.toLowerCase() !== 'home' ? (
                    <li
                      className={`breadcrumb-item text-decoration-none text-capitalize ${titleColor}`}
                      style={{ color: titleColor === 'text-picker' ? titleHexa : '' }}
                    >
                      <a>{titlePage}</a>
                    </li>
                  ) : (
                    ''
                  )}
                </>
              )}
            </ol>
          </nav>
        </div>
      </Container>
    </div>
  )
}

export default BreadCrumbs_1
